module.exports = __webpack_public_path__ + "img/cdreamslogo.8fa241bf.png";